var allItems = [];
var selectedItems = [];
var selectedItemSlots = [];
var numberOfBox = JSON.parse(localStorage.getItem("selectedItemsv1.2"))?.length;
for (let i = 0; i < numberOfBox; i++) {
    selectedItemSlots.push(null);
}


var baseUrl = ""

const allItemVanillaTemplate = (item) => `
  <div class="product-card-row ${item.selected ? "visibility-hidden" : ""}">
    <div class="box-sale-product-card">
      <div class="box-sale-product-image-div">
          <img class="box-sale-product-bg-image"
              src="${item.metafield.value}" alt="">
      </div>
      <div class="box-sale-product-details">
          <div class="box-sale-product-title">
              ${item.title}
          </div>
          <div class="product-card-fixed-bottom-container">
            <div class="box-sale-product-price">
                &#8377;&nbsp;${item.variants[0].price.amount}
            </div>
            <button
                class="box-sale-add-button custom-offer-button custom-offer-add ${
                  item.selected ? "visibility-hidden" : ""
                }"
                data-variant-id="${item.variants[0].id}">ADD TO CART</button>
            <button
                class="box-sale-add-button custom-offer-button custom-offer-remove ${
                  !item.selected ? "visibility-hidden" : ""
                }"
                data-variant-id="${item.variants[0].id}">REMOVE FROM BOX</button>
          </div>
      </div>
    </div>
  </div>
`;

const selectedItemVanillaTemplate = (item, index) => `
  <div class="selected-box-item">
    <div class="selected-product ${!item ? "active-empty" : ""} ${item ? "selected-product-background" : ""}">
        ${
          item ? `<img class="box-sale-product-bg-image" src="${item.metafield.value}" alt="">` : ``
        }
        ${
          !item
            ? `
            <div style="margin-bottom: 10px">
                ADD
            </div>
            <div>
                Item ${index + 1}
            </div>`
            : ``
        }
        <div>
            <button class="custom-offer-button custom-offer-remove close-x ${
              !item ? "visibility-hidden" : ""
            }" data-variant-id="${item ? item.variants[0].id : ""}"></button>
        </div>
    </div>
    ${item ? `<div class="selected-product-title">${item.title}</div>` : ``}
  </div>
`;

const bottomActionsVanillaTemplate = (items) => `
  <div class="bottom-actions-nudge ${getTotalPrice(items) < 1099 ? "congrats-banner" : ""}" style="${getTotalPrice(items) >= 1099 ? "background: #177D5D; color: white;" : ""}">
    ${getTotalPrice(items) < 1099 ? `Add products worth &nbsp;&#8377; ${1099 - getTotalPrice(items)} ${getTotalPrice(items) > 0 ? "more" : "" }  to unlock this offer` : "Congrats! Pay via 'CRED Pay' for extra 35% OFF"}
  </div>
  <div class="bottom-actions-container">
    <span class="bottom-actions-container-total">Total&nbsp;-&nbsp;&#8377;&nbsp; ${getTotalPrice(items)}/-</span>
    <button id="bottom-actions-container-checkout" ${getTotalPrice(items) < 1099 ? "disabled" : ""}>GO TO CART</button>
  </div>
`;




function getTotalPrice(items) {
    let totalPrice = 0;
  
    items.forEach((product) => {
      const variant = product.variants[0];
      const price = parseFloat(variant.price.amount);
      totalPrice += price;
    });
  
    return totalPrice.toFixed(2);
  }
  

function renderVanilla(allItems, selectedItems) {
  selectedItemSlots.forEach((it, index) => {
    selectedItemSlots[index] = selectedItems[index]
      ? selectedItems[index]
      : null;
  });
  $("#selected-items").html(selectedItemSlots.map(selectedItemVanillaTemplate).join(""));

  $("#all-items").html(allItems.map(allItemVanillaTemplate).join(""));

  $("#bottom-actions").html(bottomActionsVanillaTemplate(selectedItems));
}

function delegateEventHandler(event) {
  if (
    event.target.tagName === "BUTTON" &&
    event.target.classList.contains("custom-offer-add")
  ) {
    let addedItem = allItems.find(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    selectedItems.unshift(addedItem);
    selectedItemSlots.unshift(null);
    localStorage.setItem("selectedItemsv1.2", JSON.stringify(selectedItems));
    addedItem["selected"] = true;
    renderVanilla(allItems, selectedItems);
  } else if (
    event.target.tagName === "BUTTON" &&
    event.target.classList.contains("custom-offer-remove")
  ) {
    let removedItem = allItems.find(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    let removedItemInSelectedItemsIndex = selectedItems.findIndex(
      (it) => it.variants[0].id === event.target.dataset.variantId
    );
    selectedItems.splice(removedItemInSelectedItemsIndex, 1);
    selectedItemSlots.pop();
    localStorage.setItem("selectedItemsv1.2", JSON.stringify(selectedItems));
    removedItem["selected"] = false;
    renderVanilla(allItems, selectedItems);
  } else if (
    event.target.tagName === "BUTTON" &&
    event.target.id === "bottom-actions-container-checkout"
  ) {
    redirectToCheckout();
  }  else if (
    event.target.closest("div.hs-item-close > span > svg")
  ) {
    let currentVariant = event.target.dataset.id || event.target.parentElement.dataset.id || event.target.parentElement.parentElement.dataset.id || event.target.parentElement.parentElement.parentElement.dataset.id;
    currentVariant = "gid://shopify/ProductVariant/" + currentVariant;
    let removedItem = allItems.find(
      (it) => it.variants[0].id === currentVariant
    );
    let removedItemInSelectedItemsIndex = selectedItems.findIndex(
      (it) => it.variants[0].id === currentVariant
    );
    selectedItems.splice(removedItemInSelectedItemsIndex, 1);
    selectedItemSlots.pop();
    localStorage.setItem("selectedItemsv1.2", JSON.stringify(selectedItems));
    removedItem["selected"] = false;
    renderVanilla(allItems, selectedItems);
  }
}

function withoutEdgesAndNodes(data) {
  let result = Array.isArray(data) ? [] : {};

  if (typeof data !== "object") return data;

  for (const key in data) {
    if (typeof key === "string" && key === "edges") {
      result = withoutEdgesAndNodes(data.edges.map((edge) => edge.node));
    } else {
      result = Object.assign(result, {
        [key]: withoutEdgesAndNodes(data[key]),
      });
    }
  }

  return result;
}

function redirectToCheckout() {
      document.dispatchEvent(new CustomEvent('theme:cart:add',{ detail: { drawer: true, variants: selectedItems.map(it => ({quantity: 1, id: it.variants[0].id.split('/').pop()})) } }));
  }

function loadInitData() {
  let settings = {
    url: baseUrl + "/api/2023-01/graphql.json",
    method: "POST",
    timeout: 0,
    headers: {
      "X-Shopify-Storefront-Access-Token": "56cc7443a7c36761c78387a8a52b61e7",
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      query: "query {\n  products(first: 100, query: \"tag:'cred-pay'\") {\n    edges {\n      node {\n        id\n        title\n        featuredImage {\n            url\n            altText\n        } \n        metafield(namespace: \"custom\", key: \"cred_pay_product_png\") {\n            key\n            value\n        }\n        variants(first: 1) {\n            edges {\n                node {\n                    id\n                    price {\n                        amount\n                    }\n                }\n            }\n        }\n      }\n    }\n  }\n}",
      variables: {},
    }),
  };

  $.ajax(settings).done(function (response) {
    let data = withoutEdgesAndNodes(response.data);
    selectedItems = localStorage.getItem("selectedItemsv1.2")
      ? JSON.parse(localStorage.getItem("selectedItemsv1.2"))
      : [];

    let selectedItemIds = selectedItems.map((it) => it.id);
    allItems = selectedItems.length
      ? data.products.map((it) => {
          selectedItemIds.includes(it.id)
            ? (it["selected"] = true)
            : (it["selected"] = false);
          return it;
        })
      : data.products;
    renderVanilla(allItems, selectedItems);
  });
}

window.addEventListener("DOMContentLoaded", (event) => {

  document.addEventListener('click',function(event){
    try{
      delegateEventHandler(event);
    }
    catch(e) {
      console.log(e);
    }
 });
  document.querySelector(".selected-products-list").style.top = document.querySelector('#shopify-section-header').clientHeight + "px";
  loadInitData();
});
